import { createWebHistory, createRouter } from "vue-router";

/*import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";*/

/*import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";*/

/*import Home from "@/view/Home.vue";
import About from "@/view/About.vue";
import Login from "@/view/Login.vue";*/

/*const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/about", name: "About", component: About },
  { path: "/login", name: "Login", component: Login },
];*/

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../view/Home.vue"),
  },
  {
    path: "/new%20&%20trending",
    name: "NEW & TRENDING",
    component: () => import("../view/new_trending.vue"),
  },
  {
    path: "/diffusers",
    children: [
      {
        path: "",
        name: "Diffusers",
        component: () => import("../view/diffusers.vue"),
      },
      {
        path: "/diffusers/:params1",
        name: "Diffuser Type",
        component: () => import("../view/diffusers.vue"),
      },
      {
        path: "/diffusers/:params1/:params2",
        name: "Diffuser Detail",
        component: () => import("../view/product-detail.vue"),
      },
    ],
  },
  /* {
    path: "/room%20&%20fabric%20spray",
    name: "room & fabric spray",
    component: () => import("../view/room_and_fabric_spray.vue"),
  },
  {
    path: "/room%20&%20fabric%20spray/:params1",
    name: "room & fabric spray detail",
    component: () => import("../view/product-detail-spray.vue"),
  },
  /*{
    path: "/accessories",
    name: "accessories",
    component: () => import("../view/accessories-product.vue"),
  },
  {
    path: "/accessories/:params1",
    name: "accessories detail",
    component: () => import("../view/accessories-product-detail.vue"),
  },*/

  {
    path: "/accessories",
    children: [
      {
        path: "",
        name: "accessories",
        component: () => import("../view/accessories-product.vue"),
      },
      {
        path: "/accessories/:params1",
        name: "accessories type",
        component: () => import("../view/accessories-product.vue"),
      },
      {
        path: "/accessories/:params1/:params2",
        name: "accessories detail",
        component: () => import("../view/product-detail.vue"),
      },
    ],
  },
  {
    path: "/room%20&%20fabric%20spray",
    children: [
      {
        path: "",
        name: "room%20&%20fabric%20spray",
        component: () => import("../view/room_and_fabric_spray.vue"),
      },
      {
        path: "/room%20&%20fabric%20spray/:params1",
        name: "room%20&%20fabric%20spray type",
        component: () => import("../view/room_and_fabric_spray.vue"),
      },
      {
        path: "/room%20&%20fabric%20spray/:params1/:params2",
        name: "room%20&%20fabric%20spray detail",
        component: () => import("../view/product-detail.vue"),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../view/About.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
